import {
    StaticComponent
} from "../../../../../../sedestral/router/static/component/StaticComponent";
import * as s from "./mobile-navigation.scss";
import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import {Network} from "../../../../../../network/Network";
import {Resources} from "../../../../../../resources/Resources";
import {CommunityPathParams} from "../../../components/community/types/CommunityPathParams";

export class MobileNavigationStatic extends StaticComponent {

    public navigationContainer: Component;

    public rendered: boolean = false;

    constructor() {
        super();
        this.virtual(s.staticMobileNavigation);
    }

    init(): void {
        if (!this.rendered) {
            //language=HTML
            let template = `
                <div class="${s.navigation}">
                    <div class="${s.cases}">
                        <div data-path="creation" class="${s.case} ${s.home}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                        <div data-path="creation" class="${s.case} ${s.target}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                        <div data-path="optimization" class="${s.case} ${s.audit}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                        <div data-path="audit" class="${s.case} ${s.pie}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                        <div data-path="tech" class="${s.case} ${s.tech}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                        <div data-path="website" class="${s.case} ${s.blog}">
                            <div class="${s.iconContainer}">
                                <div class="${s.icon}"></div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            this.append(template);
            this.rendered = true;
            super.init();
        }

        this.displayShow();
    }

    commit() {
        this.navigationContainer = this.el(s.navigation);

        this.els(s.case)
            .forEach(caseComponent => {
                let path = caseComponent.getAttribute("data-path");
                caseComponent.onClick(() => {
                    Network.router.pages.setParam(CommunityPathParams.CONTENT, path);
                });
            });

        super.commit();
    }

    onHash() {
        this.els(s.case)
            .forEach(caseComponent => {
                caseComponent.removeClass(s.selected);
                let path = caseComponent.getAttribute("data-path");
                if (Network.router.pages.getParam(CommunityPathParams.CONTENT) == path) {
                    caseComponent.addClass(s.selected);
                }

                if (!Network.router.pages.hasParam(CommunityPathParams.CONTENT) && path == "creation")
                    caseComponent.addClass(s.selected);
            });

        super.onHash();
    }
}